import { Card } from '@/shared/components/ui/card';
import { X } from 'lucide-react';

/** M-10 최근 검색 카드 — 이력이 없으면 그리지 않는다 */
export const RecentSearchesCard = ({
  items,
  onPick,
  onRemove,
  onClear,
}: {
  items: string[];
  onPick: (keyword: string) => void;
  onRemove: (keyword: string) => void;
  onClear: () => void;
}) => {
  if (items.length === 0) return null;
  return (
    <Card className="w-full lg:w-[760px]">
      <div className="flex items-center">
        <h2 className="text-[15px] leading-[23px] font-bold text-ink">
          최근 검색
        </h2>
        <button
          type="button"
          onClick={onClear}
          className="ml-auto text-xs leading-[18px] text-ink-7 hover:text-ink-4"
        >
          전체 삭제
        </button>
      </div>
      <ul className="mt-4 flex flex-col">
        {items.map((k) => (
          <li key={k} className="flex items-center gap-2.5">
            <button
              type="button"
              onClick={() => onPick(k)}
              className="min-w-0 flex-1 truncate py-[9px] text-left text-[13px] leading-5 text-ink-2 hover:text-ink hover:underline"
            >
              {k}
            </button>
            <button
              type="button"
              aria-label={`${k} 삭제`}
              onClick={() => onRemove(k)}
              className="p-1 text-[#bbb] hover:text-ink-5"
            >
              <X className="size-3" />
            </button>
          </li>
        ))}
      </ul>
    </Card>
  );
};
